const MARKDOWN_HELP = `
# 🔄 Passthrough (입력값 그대로 전달)

**Passthrough** 기능은 입력값을 변형 없이 그대로 출력하는 기능입니다.  
데이터를 변형하지 않고 원본 그대로 유지해야 할 경우 유용하게 사용할 수 있습니다.

---

## 🛠️ 사용 방법
Passthrough는 입력을 그대로 반환하므로 **추가적인 설정이 필요 없습니다**.

### 📌 예제:
입력값이 \`"Hello, World!"\`일 때:

\`\`\`js
"Hello, World!" // 그대로 출력됨
\`\`\`

---

## ✅ 언제 사용하면 좋을까요?
✔ **임시로 변형을 적용하지 않고 싶을 때**  
✔ **디버깅용으로 원본 데이터를 유지하고 싶을 때**  
✔ **기본 값 설정을 위해 사용하고 싶을 때**  

---

## ⚠️ 주의사항
⚡ **Passthrough 기능은 입력을 수정하지 않고 그대로 반환**합니다.  
⚡ **추가적인 연산이나 변형이 필요할 경우 다른 변환 기능을 사용하세요.**  
`

export const Passthrough = {
  name: 'passthrough',
  label: 'Passthrough',
  specifications: [],
  help: MARKDOWN_HELP
}
